import { Button, Text } from '@wework/dieter-ui'
import Row from '../../Common/Row'
import React, { useEffect, useState } from 'react'
import LinkButton from './LinkButton'
import Linkeable from './Linkeable'
import LinkeableReservable from './LinkeableReservable'
import LinkPreview from './LinkPreview'
import { withSnackbar } from '../../../hoc/SnackBarProvider'
import * as _ from 'lodash'
import { withFloorMap } from '@wework/react-floormap'
import LinkeageHeader from './LinkeageHeader'
import HoldNotice from './HoldNotice'
import LoadingPlaceholder from '../../Misc/LoadingPlaceholder'
import { useSidebar } from '../../../hoc/withSidebar'

function LinkRoom({ floorMap, spaces, snackBars }) {
  const [loading, setLoading] = useState(false)
  const { closeSideBar } = useSidebar()
  const [spaceLinked, setSpaceLinked] = useState(
    spaces.length < 2 ? spaces[0]?.reservable || null : null
  )
  const getLinkingText = () => {
    return `Select an inventory item to link to this physical space so the map shows the right inventory.`
  }

  useEffect(() => {
    setSpaceLinked(spaces.length < 2 ? spaces[0]?.reservable || null : null)
    return () => {
      setSpaceLinked(null)
    }
  }, [spaces])

  const assignSystemIdToSpaces = () => {
    setLoading(true)
    let systemUUID = ''

    if (spaceLinked) {
      systemUUID = spaceLinked.uuid
    }

    return new Promise((resolve, reject) => {
      const floor = spaces[0].floorUUID

      floorMap.extensions.classification
        .assignSystemUUIDToSpacesAndDesks(floor, systemUUID, spaces)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  const refreshReservableAndBuildingIndex = async () => {
    const reservableExtension = floorMap.extensions.reservable
    const inventoryExt = floorMap.getExtension('inventoryData')

    if (!reservableExtension) {
      return
    }

    const currentBuilding = floorMap.getCurrentBuilding()
    const currentFloor = floorMap.getCurrentFloor()
    const buildingUUID = _.get(currentBuilding, 'systemUUID')

    if (!buildingUUID) {
      return
    }

    const fetchBuildingIndex = _.get(
      floorMap,
      'extensions.buildingIndex.fetchBuildingIndex',
      () => {}
    )

    await Promise.all([
      reservableExtension.fetchOccupancies(buildingUUID),
      fetchBuildingIndex(currentBuilding.uuid),
      inventoryExt.getInventory(currentFloor.uuid, true),
    ])

    return
  }

  const onLink = async () => {
    const reservableExtension = floorMap.extensions.reservable

    try {
      await assignSystemIdToSpaces()
    } catch (err) {
      console.error(err)

      snackBars.addAlert({
        text: `Ops! Something went wrong, please try again.`,
        variant: 'failed',
      })
      setLoading(false)
      return
    }

    try {
      await refreshReservableAndBuildingIndex()
      // spaces.forEach(space => {
      //   floorMap.updateData(space.uuid)
      // })

      floorMap.extensions.BASE_STYLE_EXTENSION.reload()
      reservableExtension.reloadMapStyles()
    } catch (e) {
      // setShowReloadDialog(true)
    }
    setLoading(false)
    closeSideBar()
    snackBars.addAlert({
      text: `Linked successfuly!`,
      variant: 'success',
    })
  }

  const hasReservation = spaces.filter(space =>
    Boolean(
      space.inventoryData && space.inventoryData?.relationships?.length > 0
    )
  )
  if (loading) return <LoadingPlaceholder text="Saving Linkage" />
  return (
    <>
      <LinkeageHeader spaces={spaces} />
      {spaces.length === 1 && <HoldNotice space={spaceLinked} />}
      <div style={{ marginTop: 44 }}>
        <Text size="small">{getLinkingText()}</Text>
        <Row
          style={{
            position: 'relative',
            marginTop: 24,
            marginBottom: 16,
            alignItems: 'flex-start',
          }}
        >
          <div style={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
            <Text
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 8,
              }}
              size="small"
            >
              Physical entity
            </Text>
            {spaces.map((space, index) => (
              <>
                {index > 0 && (
                  <svg width="16" height="16" style={{ alignSelf: 'center' }}>
                    <line x1="8" y1="16" x2="8" y2="0" stroke="#B0B0B0" />
                  </svg>
                )}
                <Linkeable space={space} />
              </>
            ))}
          </div>
          <LinkButton />
          <LinkeableReservable
            floorMap={floorMap}
            spaceLinked={spaceLinked}
            setSpaceLinked={setSpaceLinked}
          />
          {spaceLinked && (
            <div style={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
              <Text
                style={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                  marginBottom: 8,
                }}
                size="small"
              >
                Preview
              </Text>
              <LinkPreview space={spaceLinked} />
            </div>
          )}
        </Row>
      </div>
      <Row style={{ marginTop: 'auto' }}>
        {hasReservation.length > 0 && (
          <Text size="small">
            ⚠️ This will overwrite exisiting linked inventory.
          </Text>
        )}
        <div style={{ marginLeft: 'auto' }}>
          <Button
            variant="contained"
            size="small"
            // onClick={() => setShowLinkeage(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            primary
            size="small"
            onClick={() => onLink()}
            style={{ marginLeft: 12 }}
          >
            Save
          </Button>
        </div>
      </Row>
    </>
  )
}

export default withSnackbar(withFloorMap()(LinkRoom))
